export const navLinks = [
  { label: '首页', href: '/' },
  { label: '功能特性', href: '/#features' },
  { label: '使用场景', href: '/#use-cases' },
  { label: '常见问题', href: '/#faq' },
  { label: '关于我们', href: '/about' },
];

export const footerLinks = {
  product: {
    title: '产品',
    links: [
      { label: '功能特性', href: '/#features' },
      { label: '使用场景', href: '/#use-cases' },
      { label: '定价方案', href: '/#pricing' },
      { label: '更新日志', href: '/#' },
    ],
  },
  resources: {
    title: '资源',
    links: [
      { label: '帮助中心', href: '/#' },
      { label: '使用指南', href: '/#' },
      { label: 'API 文档', href: '/#' },
      { label: '社区论坛', href: '/#' },
    ],
  },
  company: {
    title: '公司',
    links: [
      { label: '关于我们', href: '/about' },
      { label: '联系我们', href: '/about#contact' },
      { label: '加入我们', href: '/#' },
      { label: '隐私政策', href: '/#' },
    ],
  },
};

export const companyInfo = {
  name: '一起草',
  slogan: '让团队协作起草更高效、更顺畅',
  email: 'contact@hteoapeks.cn',
  phone: '400-888-9999',
  address: '北京市海淀区中关村科技园A座1208室',
  icp: '京ICP备2024XXXXXX号',
};